import PropTypes from 'prop-types'
import styled from 'styled-components'
import React, { Component, Fragment } from 'react'
import { Button, Popconfirm, Tabs, Icon, Pagination } from 'antd'
import CreateCompanyContactForm from './CreateCompanyContactForm'
import SelectExistingContact from './SelectExistingContact'
import history from '../history'
import SingleView from './SingleView'
import { drop } from 'lodash'

const TabPane = Tabs.TabPane

const StyledTabs = styled(Tabs)`
  padding: 15px;
  background-color: #f7f7f7;
`
const propTypes = {
  primaryContactId: PropTypes.number
}
class ContactsQuickAdd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contactFormShowing: false,
      contactData: null,
      page: 1
    }
  }

  setPage = page => {
    this.setState({
      page
    })
  }

  getPagedData = () => {
    const { page } = this.state
    const data = this.props.companyContacts
    const offset = (page - 1) * 10
    return drop(data, offset).slice(0, 10)
  }

  handleCreateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.handleCreateContactButton(contactData)
  }

  handleCreateContactByIdButton = contactId => {
    this.setState({
      contactFormShowing: false
    })
    this.props.handleCreateContactByIdButton(contactId)
  }

  handleUpdateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.handleUpdateContactButton(contactData)
  }

  handleAddContactButton = () => {
    this.setState({
      contactFormShowing: true
    })
  }

  handleCancelContactButton = () => {
    this.setState({
      contactFormShowing: false
    })
  }

  handleContactShortcut = row => {
    history.push(`/contacts/${row.id}`)
  }

  render() {
    return (
      <div className="">
        <div className="jobsBar">
          Contacts
          {!this.state.contactFormShowing && (
            <div className="jobsBarAdd" onClick={() => this.handleAddContactButton()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">ADD CONTACT</div>
            </div>
          )}
          {this.state.contactFormShowing && (
            <div className="displayFlex">
              <div className="jobsBarAdd" onClick={() => this.handleCancelContactButton()}>
                <i className="fa fa-ban" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">CANCEL</div>
              </div>
            </div>
          )}
        </div>
        {this.state.contactFormShowing && (
          <StyledTabs defaultActiveKey="1">
            <TabPane tab="Search existing contact" key="1">
              <SelectExistingContact
                allContacts={this.props.allContacts}
                addContact={this.handleCreateContactByIdButton}
              />
            </TabPane>
            <TabPane tab="Add new Contact" key="2">
              <CreateCompanyContactForm
                addContact={this.handleCreateContactButton}
                saveContact={this.handleUpdateContactButton}
                contentData={this.state.contactData}
              />
            </TabPane>
          </StyledTabs>
        )}
        <SingleView
          title="Contacts"
          emptyText="No contacts for this vendor"
          data={this.getPagedData()}
          getKey={c => c.id}
          getHeader={c => `${c.first_name} ${c.last_name}`}
        >
          {c => (
            <Fragment>
              <div className="row">
                <div className="col-md-4">
                  <div className="jobDetailsHeader">Name:</div>
                  <span>
                    {c.first_name} {c.last_name}
                  </span>
                </div>
                <div className="col-md-4">
                  <div className="jobDetailsHeader">Title:</div>
                  <span>{c.title}</span>
                </div>
                <div className="col-md-4">
                  <Popconfirm
                    title="Are you sure you want to make this the primary contact for this company?"
                    onConfirm={() => this.props.handleMakePrimaryContact(c.id)}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button size="small" type="link" style={{ color: '#1F45B4' }}>
                      <Icon type="star" theme={c.is_primary_contact ? 'filled' : 'outlined'} />
                    </Button>
                  </Popconfirm>
                  <Button
                    size="small"
                    icon="export"
                    onClick={() => this.handleContactShortcut(c)}
                    className="marginLeft5"
                  />
                  <Popconfirm
                    title="Are you sure you want to delete this line?"
                    onConfirm={() => this.props.handleDeleteContact(c.id)}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button size="small" className="marginLeft5" type="danger" icon="delete" />
                  </Popconfirm>
                </div>
              </div>
            </Fragment>
          )}
        </SingleView>
        <Pagination
          total={this.props.companyContacts ? this.props.companyContacts.length : 0}
          pageSize={10}
          current={this.state.page}
          defaultCurrent={1}
          onChange={this.setPage}
        />
      </div>
    )
  }
}
ContactsQuickAdd.propTypes = propTypes
export default ContactsQuickAdd



// WEBPACK FOOTER //
// ./src/components/ContactsQuickAdd.js